import React from "react"

export const Completed = () => (
<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10 13H16.3875"
    stroke="#0D0C1C"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10 16.6849H16.3875"
    stroke="#0D0C1C"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M18.8552 15C18.8552 13.6433 19.8085 12.5433 20.9844 12.5433V8.24402H5.01562V12.5433C6.19146 12.5433 7.14479 13.6433 7.14479 15C7.14479 16.3568 6.19146 17.4568 5.01562 17.4568V21.756H20.9844V17.4568C19.8085 17.4568 18.8552 16.3568 18.8552 15Z"
    stroke="#0D0C1C"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M24 28C27.3137 28 30 25.3137 30 22C30 18.6863 27.3137 16 24 16C20.6863 16 18 18.6863 18 22C18 25.3137 20.6863 28 24 28Z"
    fill="#28BE63"
    stroke="#28BE63"
    strokeWidth="0.853333"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M24 28C27.3137 28 30 25.3137 30 22C30 18.6863 27.3137 16 24 16C20.6863 16 18 18.6863 18 22C18 25.3137 20.6863 28 24 28Z"
    fill="#28BE63"
    stroke="#28BE63"
    strokeWidth="0.853333"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M21.1992 22L23.0659 24L26.7992 20"
    stroke="white"
    strokeWidth="0.853333"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

)
